const url = process.env.GATSBY_DRUPAL_ROOT;

class StockService { 
  getStockValue = async (stock) => {
    const res = await fetch(`${url}/stock-available/${stock}`, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json'
      },
    });
    const stockValue = await res.json();
    return stockValue;
  }
}
const StockHandler = new StockService();
export default StockHandler;
